/**
 * Check whether an object has a property.
 */
export const hasProp = <T extends object, K extends string>(obj: T, key: K): obj is T & {[k in K]: unknown} =>
	Object.bind(obj).hasOwnProperty(key);
